
const ASSETS={
    LOGO: "/assets/images/theLogo.jpg",
    LOGO_TRANSPARENT: "/assets/images/theLogo-transparent.png",
    LOYALTY_CARD: "/assets/images/loyaltyCard.png",
    BIRTHDAY_PRESENT: "/assets/images/birthdayPresent.png",
    REWARDS: "/assets/images/rewards.png",
    REWARD_CONFIG: "/assets/images/reward-config.png",
    TIER_BENEFITS: "/assets/images/tier-benefit.png",
    TIER_CONFIG: "/assets/images/tier-config.png",
    LANDING_PAGE_LOGO: "/assets/images/theLogoGif.gif",
    LANDING_PAGE_JOIN: "/assets/images/join.svg",
    LANDING_PAGE_EARN: "/assets/images/earn.svg",
    LANDING_PAGE_REDEEM: "/assets/images/redeem.svg",
    TIER_IMAGE: "/assets/images/trophy.png",
    REWARD_IMAGE: "/assets/images/redeem.svg",
    CARD_IMAGE: "/assets/images/card.png"
  }

  export {ASSETS}